const handleDeleteCompanyFormCompany = {
  text: '¿Realmente desea eliminar esta empresa?',
  title: 'ELIMINAR EMPRESA',
};

export default handleDeleteCompanyFormCompany;
